/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const StockAdjustmentDetailPage = lazyLoad(
  () => import('./index'),
  module => module.StockAdjustmentDetailPage
);
